import { render, staticRenderFns } from "./TourismNewsForm.vue?vue&type=template&id=9c1abf86&"
import script from "./TourismNewsForm.vue?vue&type=script&lang=js&"
export * from "./TourismNewsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports